<div class="coming-soon">
  <img
    class="lang-specific-comingsoon-bg-img"
    [appImageSprite]="'menu_bg_gold'"
    [params]="menu_icons"
  />
  <div class="coming-soon-opacity" (click)="onClick($event)">
    <div
      class="lang-specific-undercons-text lang-specific-font-name-menu lang-specific-right_to_left_direction"
    >
      {{ 'LANG00197' | translate }}!
    </div>
    <img
      class="lang-specific-comingsoon-img lang-specific-right_to_left_direction"
      [appImageSprite]="'coming_soon_logo'"
      [params]="menu_icons"
    />
    <div
      class="lang-specific-comingsoon-text lang-specific-font-name-menu lang-specific-right_to_left_direction"
    >
      {{ 'LANG00198' | translate }}!
    </div>
  </div>
</div>
